import { Artist } from 'graphql/types';

type FilterableArtist = Pick<Artist, 'name'>;

// NOTE: Cowritten (mostly written) by chatGPT - Brad

export const getFilteredArtists = (artists: FilterableArtist[], filter: string) => {
  if (!filter) return artists;

  // Remove diacritical marks from the filter string,
  // replace non-word characters (including hyphens and slashes) with empty string,
  // remove control characters (like newline),
  // and convert to lower case for case-insensitive matching
  const sanitizedFilter = filter
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^\w\s]/g, '')
    .replace(/\s+/g, '')
    // eslint-disable-next-line no-control-regex
    .replace(/[\x00-\x1F\x7F-\x9F]/g, '')
    .toLowerCase();

  // Create the Regex Pattern with 'g' flag for global search
  const regexp = new RegExp(sanitizedFilter, 'g');

  // Perform the Filtering
  return artists.filter(artist => {
    // Apply the same sanitization process to the artist name
    const sanitizedArtistName = artist.name
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^\w\s]/g, '')
      .replace(/\s+/g, '')
      // eslint-disable-next-line no-control-regex
      .replace(/[\x00-\x1F\x7F-\x9F]/g, '')
      .toLowerCase();

    return regexp.test(sanitizedArtistName);
  });
};
